module.exports = "/_next/static/images/img__video-1387c6eb480f5b43618380321352735c.png";